import React from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

/**
 * Backstop toast for VIEW-ONLY locations.
 *
 * Every write control is greyed out by <WriteGuard>, so in normal use
 * this never fires. It exists for the paths the sweep can't cover — a
 * keyboard shortcut, an auto-save timer, a retry from an outbox, or a
 * control added later and not yet guarded. Without it those all fail
 * silently and the screen just looks broken.
 *
 * Self-contained on purpose: it listens for the `app:readonly` window
 * event AuthUtil raises on an HTTP 403 + readOnly response, rather than
 * going through the shared redux error bar, so mounting it once in Base
 * can't collide with the pages that mount their own ErrorFeedbackBar.
 */
class ReadOnlyToast extends React.PureComponent {
  state = { open: false, message: '' };

  componentDidMount() {
    window.addEventListener('app:readonly', this.handleReadOnlyEvent);
  }

  componentWillUnmount() {
    window.removeEventListener('app:readonly', this.handleReadOnlyEvent);
  }

  handleReadOnlyEvent = (event) => {
    const message =
      event?.detail?.message ||
      'You have view-only access at this location.';
    this.setState({ open: true, message });
  };

  handleClose = () => this.setState({ open: false });

  render() {
    return (
      <Snackbar
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert variant="filled" severity="info" onClose={this.handleClose}>
          {this.state.message}
        </Alert>
      </Snackbar>
    );
  }
}

export default ReadOnlyToast;
